export {
  postConfig,
  initMessaging,
  setSettingsItems,
  postBadgeVisibilityConfig,
  removeSettingsItems,
} from './windowMessaging';
